import React, { Fragment } from 'react';

import useListboxFetch from "./useListboxFetch";
import { CommonDropdown } from "./CommonDropdown";
import SpinnerDiv from "ui/ReactSpinnerDiv";

const DropdownProviderEYFSGroupMembers = ({ control, onChange, name, rules, placeholder, isSearchable, isClearable, isMulti, readOnly, enc_group_id} ) =>
{
    const mapFn = ( record )  =>
    {
        return {
            ...record, full_name: record.forename + ' ' + record.surname
        }
    }

    const url = enc_group_id === null ? null : '/groups/' + enc_group_id + '/members' ;

    const fields = { url: url, keyFieldName: 'user_account_id', labelFieldName: 'full_name', mapFn: mapFn }

    const [ loading, items ] = useListboxFetch( fields ) ;

    return (
        <Fragment>
            { loading === true && <div className='form-control'><SpinnerDiv/></div> }
            { loading === false && <CommonDropdown items={items} control={control} onChange={onChange} name={name} rules={rules} placeholder={placeholder} isSearchable={isSearchable} isClearable={isClearable} isMulti={isMulti} readOnly={readOnly} /> }
        </Fragment>
    )
}

export default DropdownProviderEYFSGroupMembers;
